interface IAboutData {
  fromAuthor: string[];
  aboutTaro: string[];
  spreads: string[];
  aboutAuthor: string[];
}

export const aboutData: IAboutData = {
  fromAuthor: [
    "Здравствуйте!",
    "Это приложение объединяет справочник по картам Таро и инструменты для работы с раскладами.",
    "Вы можете изучать значения карт, их символику, архетипические и психологические аспекты, трактовки для разных жизненных контекстов, сочетания, советы для чтения и вопросы для саморефлексии.",
    "Для раскладов используется отдельная система интерпретации: каждая позиция получает свою карту и набор смысловых разделов в зависимости от структуры выбранного расклада.",
  ],

  aboutTaro: [
    "Таро — система символов и архетипов, помогающая отражать текущее состояние и рассматривать возможные варианты действий.",
    "Карты полезны не только для прогноза: они помогают структурировать мысли, прояснять мотивации и замечать аспекты ситуации, которые легко упустить.",
    "В приложении представлены значения карт по личностному аспекту, отношениям, работе и духовной теме, а также перевёрнутые значения, советы для чтения и вопросы для самопознания.",
    "Интерпретация расклада строится не только из значения отдельной карты, но и с учётом смысла позиции, которую карта занимает в выбранной схеме.",
  ],

  spreads: [
    "В приложении собран каталог раскладов разной сложности: от одной, двух и трёх карт до больших многопозиционных схем.",
    "Для каждого расклада указаны его назначение, количество карт, позиции и их смысл. Для части схем также доступны дополнительные сведения о символике, архетипах и особенностях интерпретации.",
    "В каталоге представлены как компактные расклады для быстрого анализа ситуации, так и более подробные схемы для отношений, выбора, жизненного пути, психологического анализа и периодического прогноза.",
    "При запуске расклада карты выбираются из общей колоды без повторов. Каждая карта связывается с конкретной позицией расклада, после чего формируется соответствующая интерпретация.",
    "Каталог раскладов продолжает развиваться: новые схемы добавляются через данные и отдельные профили чтения, без привязки логики расклада к конкретному React-компоненту.",
  ],

  aboutAuthor: [
    "Проект развивается как pet-проект, посвящённый структурированию значений Таро и созданию удобного интерфейса для работы с картами и раскладами.",
    "Основная цель — отделить данные карт, правила интерпретации и пользовательский интерфейс, чтобы приложение можно было постепенно расширять без усложнения основной логики.",
    "Функциональность, структура раскладов и интерфейс дорабатываются поэтапно по мере развития проекта.",
  ],
};

